import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface RefreshState {
    [moduleName: string]: boolean;
}

interface ModuleDataState {
    [moduleName: string]: any;
}

const initialRefreshState: RefreshState = {};
const initialModuleDataState: ModuleDataState = {};

// const initialState: RefreshState = {};
const initialState = {
    refresh: initialRefreshState,
    data: initialModuleDataState
};

const refreshSlice = createSlice({
    name: 'refresh',
    initialState,
    reducers: {

        setModuleRefresh(state, action: PayloadAction<{ moduleName: string; refresh: boolean }>) {
            const { moduleName, refresh } = action.payload;
            state.refresh[moduleName] = refresh;
        },

        clearModuleRefresh(state, action: PayloadAction<{ moduleName: string }>) {
            const { moduleName } = action.payload;
            delete state.refresh[moduleName];
        },

        setModuleData(state, action: PayloadAction<{ moduleName: string; data: any  }>) {
            const { moduleName, data } = action.payload;
            state.data[moduleName] = data;
        },

        clearModuleData(state, action: PayloadAction<{ moduleName: string }>) {
            const { moduleName } = action.payload;
            delete state.data[moduleName];
        },

        setModule(state, action: PayloadAction<{ moduleName: string; refresh: boolean; data: any  }>) {
            const { moduleName, refresh, data } = action.payload;
            state.refresh[moduleName] = refresh;
            state.data[moduleName] = data;
        },

        clearModule(state, action: PayloadAction<{ moduleName: string }>) {
            const { moduleName } = action.payload;
            delete state.refresh[moduleName];
            delete state.data[moduleName];
        },

        // resetRefresh() {
        //     return {};
        // }
        resetRefresh(state) {
            state.refresh = {};
            state.data = {};
        }
    }
});

export const { setModuleRefresh, clearModuleRefresh, setModuleData, clearModuleData, setModule, clearModule, resetRefresh } = refreshSlice.actions;
export default refreshSlice.reducer;
